import { render, staticRenderFns } from "./DebtCollectionList.vue?vue&type=template&id=c0c0dda8&scoped=true&"
import script from "./DebtCollectionList.vue?vue&type=script&lang=js&"
export * from "./DebtCollectionList.vue?vue&type=script&lang=js&"
import style0 from "./DebtCollectionList.vue?vue&type=style&index=0&id=c0c0dda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0dda8",
  null
  
)

export default component.exports